declare let CalcTranslations;

let prefix = 'calc_';
let prefix2 ="b2calculator_"

export const translate = (key: string) => {
    if (CalcTranslations[prefix + key])
        return CalcTranslations[prefix + key];
    else if (CalcTranslations[prefix2 + key])
        return CalcTranslations[prefix2 + key];
    else if(CalcTranslations[key])
        return CalcTranslations[key];
    return key;
}